import { kebabCase, memoize } from 'lodash-es';

import { MultiVariantModuleConfig } from '../types';

export const importModule = memoize(
  async <T>(featureFlagName: string) => {
    const moduleName = kebabCase(featureFlagName);
    const [singleVariantModule, multipleVariantModule] = await Promise.all([
      import(/* @vite-ignore */ `../../single-variant/${moduleName}`).catch(() => undefined),
      import(/* @vite-ignore */ `../../multiple-variant/${moduleName}`).catch(() => undefined),
    ]);
    if (singleVariantModule !== undefined && multipleVariantModule !== undefined) {
      throw new Error(`Duplicate feature-flag ${moduleName} modules were found`);
    }
    if (singleVariantModule !== undefined) {
      throw new Error(`Using single variant feature-flag (${featureFlagName}) with multi variant feature-flag hooks is not allowed`);
    }
    if (multipleVariantModule === undefined) {
      throw new Error(`Feature flag (${moduleName}) module not found`);
    }

    return multipleVariantModule as MultiVariantModuleConfig<T>;
  },
  (ffName: string) => kebabCase(ffName),
);
